import React from "react";
import PropTypes from "prop-types";
import useCatalogProductSlots from "../../core/use-catalog-product-slots.jsx";
import shared from "../../core/catalog-shared.module.css";
import styles from "./VerticalProductLayout.module.css";

export default function VerticalProductLayout(props) {
  const {
    productData,
    productIndex,
    mobileCardDensity = "single",
    isMobile,
  } = props;

  const {
    imageBlock,
    metaBlock,
    controlsBlock,
    descriptionBlock,
    cardShellStyle,
    isTwinMobileCard,
  } = useCatalogProductSlots({
    ...props,
    isHorizontal: false,
    mobileCardDensity,
  });

  return (
    <article
      className={`${styles.root} ${
        isTwinMobileCard ? styles.mobileTwin : ""
      } ${isMobile ? styles.mobile : ""} ${
        isTwinMobileCard ? shared.mobileTwinRoot : ""
      }`.trim()}
      style={cardShellStyle}
      data-product-index={productIndex}
      data-shell-layout="vertical-v1"
    >
      <div className={styles.imageSlot}>{imageBlock}</div>
      <div className={styles.bodySlot}>
        {metaBlock}
        {controlsBlock}
        {descriptionBlock}
      </div>
    </article>
  );
}

VerticalProductLayout.propTypes = {
  section: PropTypes.object,
  productData: PropTypes.object,
  productIndex: PropTypes.number,
  popupData: PropTypes.object,
  isMobile: PropTypes.bool,
  mobileCardDensity: PropTypes.oneOf(["single", "twin"]),
};
